import { TabPanelProps } from "../../config/interfaces";
import { Box } from "@mui/material";
import React from "react";

export const TabPanel = ({
  children,
  value,
  index,
  pt = 0,
  ...other
}: TabPanelProps) => {
  return (
    <Box
      pt={pt}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Box>{children}</Box>
        </Box>
      )}
    </Box>
  );
};
